/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnnouncementNotificationActionData
 */
export interface AnnouncementNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof AnnouncementNotificationActionData
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementNotificationActionData
     */
    pushBody: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementNotificationActionData
     */
    shortDescription: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementNotificationActionData
     */
    longDescription: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementNotificationActionData
     */
    route: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementNotificationActionData
     */
    dashboardAnnouncementId?: string | null;
}

/**
 * Check if a given object implements the AnnouncementNotificationActionData interface.
 */
export function instanceOfAnnouncementNotificationActionData(value: object): value is AnnouncementNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "title" in value && value["title"] !== undefined;
    isInstance = isInstance && "pushBody" in value && value["pushBody"] !== undefined;
    isInstance = isInstance && "shortDescription" in value && value["shortDescription"] !== undefined;
    isInstance = isInstance && "longDescription" in value && value["longDescription"] !== undefined;
    isInstance = isInstance && "route" in value && value["route"] !== undefined;

    return isInstance;
}

export function AnnouncementNotificationActionDataFromJSON(json: any): AnnouncementNotificationActionData {
    return AnnouncementNotificationActionDataFromJSONTyped(json, false);
}

export function AnnouncementNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnnouncementNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'pushBody': json['push_body'],
        'shortDescription': json['short_description'],
        'longDescription': json['long_description'],
        'route': json['route'],
        'dashboardAnnouncementId': !exists(json, 'dashboard_announcement_id') ? undefined : json['dashboard_announcement_id'],
    };
}

export function AnnouncementNotificationActionDataToJSON(value?: AnnouncementNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'push_body': value.pushBody,
        'short_description': value.shortDescription,
        'long_description': value.longDescription,
        'route': value.route,
        'dashboard_announcement_id': value.dashboardAnnouncementId,
    };
}

